import { displayImportedText } from '../services/displayLabels';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { patientsApi } from '../services/api';
import './clinic.css';

export function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const [patients, setPatients] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedPatientId, setSelectedPatientId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try { setPatients(await patientsApi.getAll() || []); }
    catch (loadError) { setError(loadError.message || 'Non è stato possibile caricare i pazienti.'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const filtered = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return patients.slice(0, 12);
    return patients.filter(patient => `${patient.lastName} ${patient.firstName} ${patient.code || ''} ${displayImportedText(patient.code) || ''}`.toLowerCase().includes(query)).slice(0, 20);
  }, [patients, search]);

  const biaRequested = location.pathname === '/bia';
  const start = patientId => navigate(`/patients/${patientId}/visits/new${biaRequested ? '?bia=1' : ''}`);

  return <div className="clinic-page visit-launcher" aria-busy={loading}>
    <header className="clinic-head">
      <div><h1>{biaRequested ? 'Avvia visita con BIA' : 'Avvia una visita'}</h1><p>Prima scegli il paziente: visita, rilevazioni e documenti resteranno nella sua cartella clinica.</p></div>
    </header>
    {error && <div className="dashboard-state-error" role="alert"><div><strong>Pazienti non disponibili</strong><span>{error}</span></div><button type="button" onClick={load} disabled={loading}>{loading ? 'Nuovo tentativo…' : 'Riprova'}</button></div>}
    <section className="clinic-panel visit-launch-panel">
      <div className="visit-launch-copy"><h2>Con chi stai iniziando la visita?</h2><p>{biaRequested ? 'Il paziente resterà selezionato per antropometria, annotazioni e misurazione bioimpedenziometrica.' : 'Il paziente resterà selezionato per note, rilevazioni e tutte le attività della visita.'}</p></div>
      <div className="visit-launch-search">
        <label htmlFor="visitPatientSearch">Cerca paziente</label>
        <input id="visitPatientSearch" value={search} onChange={event => setSearch(event.target.value)} placeholder="Nome, cognome o codice interno" autoComplete="off"/>
      </div>
      <div className="visit-launch-list" aria-label="Pazienti disponibili" aria-live="polite">
        {loading && patients.length === 0 && <div className="dashboard-state-loading" role="status">Sto caricando le cartelle paziente…</div>}
        {filtered.map(patient => <button type="button" key={patient.id} className={selectedPatientId === patient.id ? 'selected' : ''} aria-pressed={selectedPatientId===patient.id} onClick={() => setSelectedPatientId(patient.id)}>
          <span className="clinic-avatar">{patient.firstName?.[0]}{patient.lastName?.[0]}</span>
          <span><strong>{patient.lastName} {patient.firstName}</strong><small>{displayImportedText(patient.code) || 'Senza codice'} · {patient.dateOfBirth ? new Date(`${patient.dateOfBirth}T00:00:00`).toLocaleDateString('it-IT') : 'Data di nascita assente'}</small></span>
          <span className="visit-select-mark" aria-hidden="true" />
        </button>)}
        {!loading && !error && !filtered.length && <div className="clinic-empty">{search ? 'Nessun paziente corrisponde alla ricerca.' : 'Non ci sono ancora cartelle paziente.'}</div>}
      </div>
      <div className="visit-launch-actions">
        <button className="clinic-button secondary" onClick={() => navigate('/patients')}>Apri archivio pazienti</button>
        <button className="clinic-button" disabled={!selectedPatientId} onClick={() => start(selectedPatientId)}>Avvia visita</button>
      </div>
    </section>
  </div>;
}

Home.displayName = Home.name;

export default Home;
